import Vue from "vue";
import Vuex from "vuex";

import api from "./api";
import localStorageService from "./services/LocalStorage";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    stationInfo: localStorageService.getStationInfo(),
    failedSyncHistory: [],
    user: JSON.parse(localStorage.getItem("user"))
  },
  getters: {
    isAuthenticated: state => !!state.user,
    isAdmin: state => state.user.data.role == "admin"
  },
  mutations: {
    setStationInfo(state, stationData) {
      state.stationInfo = stationData;
      localStorageService.setStationInfo(stationData);
    },

    failedSyncHistory(state, newScan) {
      state.failedSyncHistory.push(newScan);
    },

    setUser(state, user) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
    clearUser(state) {
      state.user = null;
      localStorage.removeItem("user");
      localStorageService.removeAccessKeys();
      // localStorageService.removeStationInfo();
      state.stationInfo = [];
    }
  },
  actions: {
    getStationInfo({ commit }) {
      if (this.getters.isAuthenticated && !this.getters.isAdmin) {
        api.getStationInfo().then(response => {
          commit("setStationInfo", response.data);
        });
      }
    },

    setStationInfo({ commit }, stationInfo) {
      commit("setStationInfo", stationInfo);
    },

    updateFailedSync({ commit }, newScan) {
      commit("failedSyncHistory", newScan);
    },

    signIn({ commit }, { email, password }) {
      return new Promise((resolve, reject) => {
        api
          .createSession(email, password)
          .then(response => {
            // Store credentials
            localStorageService.setAccessKeys(response.headers);
            commit("setUser", response.data);

            // Get station configurations
            this.dispatch("getStationInfo");

            resolve();
          })
          .catch(error => {
            // if the request fails, clear user
            commit("clearUser");
            reject(error.response.data.error);
          });
      });
    },
    signOut({ commit }) {
      // The Promise used for router redirect in AppHeader.vue
      return new Promise(resolve => {
        api.deleteSession().then(() => {
          commit("clearUser");
          resolve();
        });
      });
    },
    clearUser({ commit }) {
      return new Promise(resolve => {
        commit("clearUser");
        resolve();
      });
    }
  }
});
